import LegalShell, { Fill, LegalSection } from "@/components/LegalShell";
import { COMPANY as C } from "@/pages/legal/companyInfo";
import Seo from "@/components/Seo";

export default function Privacy() {
  return (
    <LegalShell eyebrow="Confidentialité" title="Politique de confidentialité" updated={C.updated}>
      <Seo title="Politique de confidentialité — BIZARRE AI" description="Comment BIZARRE AI collecte, utilise et protège vos données personnelles (RGPD)." path="/privacy" />
      <LegalSection n="1" title="Responsable du traitement">
        <p>Le responsable du traitement de vos données est <Fill>{C.raisonSociale}</Fill>.
        Contact : <Fill>{C.email}</Fill> — Délégué à la protection des données : <Fill>{C.dpoEmail}</Fill></p>
      </LegalSection>
      <LegalSection n="2" title="Données que nous collectons">
        <p>Nous collectons les informations que vous fournissez : nom, adresse e-mail, mot de passe (chiffré),
        les contenus que vous générez (réponses, analyses, scripts, débats, courriers) et vos statistiques
        d'utilisation. Si vous vous connectez via Google, nous recevons votre nom, e-mail et photo de profil.</p>
      </LegalSection>
      <LegalSection n="3" title="Finalités et bases légales">
        <p>Vos données sont traitées pour : fournir le service (exécution du contrat), gérer votre abonnement
        (obligation contractuelle et légale/comptable), améliorer l'application (intérêt légitime) et assurer la
        sécurité. Les textes soumis à l'IA sont transmis à notre fournisseur de modèle de langage uniquement pour
        produire votre réponse.</p>
      </LegalSection>
      <LegalSection n="4" title="Durées de conservation">
        <p>Vos données de compte sont conservées tant que votre compte est actif. En cas de suppression, elles
        sont effacées immédiatement, à l'exception des données de facturation conservées le temps requis par les
        obligations légales et comptables.</p>
      </LegalSection>
      <LegalSection n="5" title="Caméra & images">
        <p>La fonction « Scanner un commentaire » utilise votre caméra ou vos photos uniquement pour extraire le
        texte de l'image (OCR). Les images ne sont pas conservées de façon permanente à cet effet.</p>
      </LegalSection>
      <LegalSection n="6" title="Paiements">
        <p>Les paiements web sont traités par <span className="text-white">Stripe</span> ; les abonnements iOS par
        <span className="text-white"> Apple</span> et Android par <span className="text-white">Google Play</span>.
        Nous ne stockons jamais vos données de carte bancaire.</p>
      </LegalSection>
      <LegalSection n="7" title="Cookies & stockage local">
        <p>L'application utilise le stockage local de votre navigateur (localStorage) pour des besoins strictement
        nécessaires à son fonctionnement : maintien de votre session (jeton d'authentification), préférences
        d'affichage et suivi de l'onboarding. Aucun cookie publicitaire ou de traçage tiers n'est utilisé.</p>
      </LegalSection>
      <LegalSection n="8" title="Partage des données">
        <p>Nous ne vendons pas vos données. Elles ne sont partagées qu'avec les sous-traitants strictement
        nécessaires au service : hébergeur, fournisseur d'IA, prestataires de paiement (Stripe, Apple, Google).</p>
      </LegalSection>
      <LegalSection n="9" title="Vos droits (RGPD)">
        <p>Vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation, d'opposition et de
        portabilité. Depuis <span className="text-white">Profil → Confidentialité</span>, vous pouvez à tout
        moment <span className="text-white">exporter vos données</span> ou <span className="text-white">supprimer
        définitivement votre compte</span>. Vous pouvez aussi introduire une réclamation auprès de la CNIL.</p>
      </LegalSection>
      <LegalSection n="10" title="Sécurité">
        <p>Les échanges sont chiffrés (HTTPS), les mots de passe hachés. Les clés d'API restent côté serveur et ne
        sont jamais exposées dans l'application.</p>
      </LegalSection>
      <LegalSection n="11" title="Contact">
        <p>Pour exercer vos droits ou toute question : <Fill>{C.email}</Fill></p>
      </LegalSection>
    </LegalShell>
  );
}
